import { render, staticRenderFns } from "./earning.vue?vue&type=template&id=5b035e37"
import script from "./earning.vue?vue&type=script&lang=js"
export * from "./earning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports